import React from 'react';
import { connect } from 'react-redux';
import { PhoneInput } from "./components/PhoneInput";
import { AddressInput, AddressNotAvailableBlock, AlternativeTariffBlock, ConnectionNotification } from "./components";
import { getCheckAddressStatus, getOrderTariffInlineTexts, getTargetTariffType } from "../../../store/selectors";
import { ContentHeader } from "../../common/ContentHeader";
import { ModalLayout } from "../../common/ModalLayout";
var _CheckAddressInlineForm = function _CheckAddressInlineForm(_ref) {
  var orderTariffInlineTitle = _ref.orderTariffInlineTitle;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    "data-t-id": "Steps-CheckAddressInlineForm"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    title: orderTariffInlineTitle,
    "data-t-id": "Steps-CheckAddressInlineForm"
  }), /*#__PURE__*/React.createElement(AddressInput, null), /*#__PURE__*/React.createElement(ConnectionNotification, null), /*#__PURE__*/React.createElement(PhoneInput, null), /*#__PURE__*/React.createElement(AlternativeTariffBlock, null), /*#__PURE__*/React.createElement(AddressNotAvailableBlock, null));
};
var mapStateToProps = function mapStateToProps(state) {
  var _getOrderTariffInline;
  return {
    orderTariffInlineTitle: (_getOrderTariffInline = getOrderTariffInlineTexts(state)) === null || _getOrderTariffInline === void 0 ? void 0 : _getOrderTariffInline.title,
    statusConnection: getCheckAddressStatus(state),
    tariffType: getTargetTariffType(state),
    texts: getOrderTariffInlineTexts(state).phoneInputTexts
  };
};
var connector = connect(mapStateToProps);
export var CheckAddressInlineForm = connector(_CheckAddressInlineForm);